import { FilterSection } from "@flights/search-ui";
import React from "react";
import { useStopsFilterController } from "./useStopsFilter.controller.js";
import { Stack } from "@bookingcom/bui-react";
import { StopsFilterItem } from "./StopsFilterItem.js";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
import { t, useI18n } from "@bookingcom/lingojs-react";
export const StopsFilterMobile = () => {
    const { title, showReset, resetLabel, onClickReset, options, value, onChange, isFilterAvailable } = useStopsFilterController();
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    const i18n = useI18n();
    if (!isFilterAvailable) {
        return null;
    }
    return (React.createElement(FilterSection, { attributes: { "data-testid": "stops_filter" }, title: {
            text: title,
            tagName: "h3",
            attributes: { id: "stops_filter" },
            variant: trackLayoverPriceAirportFilterWeb() ? "strong_2" : "emphasized_1"
        }, reset: showReset
            ? {
                text: resetLabel,
                onClick: onClickReset,
                attributes: {
                    "data-testid": "search_filter_stops_reset",
                    "aria-label": i18n.trans(t("a11y_flights_filter_reset_stops"))
                }
            }
            : undefined },
        React.createElement(Stack, { gap: 4 }, options.map((option, i) => (React.createElement(StopsFilterItem, { key: `${option.label}-${i}-${option.count}`, label: option.label, priceLabel: option.priceLabel, count: option.count, value: option.value, checked: value === option.value, onChange: onChange }))))));
};
